var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"hasAdd":"","table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"loading":_vm.loading,"current-page":_vm.page},on:{"onAdd":_vm.handleAdd,"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleClick,"onChange":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }